import StateError from 'app/KinerjaShared/components/StateError'

import type { FC } from 'react'

type Props = {}

const PageError: FC<Props> = ({}) => {
  return <StateError onClick={() => window.location.reload()} />
}

export default PageError
